import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Link, type LinkProps } from "react-router-dom";

const baseClassName =
  "inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 font-medium transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-60";

const variants = {
  primary: "bg-[#0293cc] text-white hover:bg-[#03aeef] shadow-sm font-semibold tracking-wide",
  secondary: "border border-ink/25 bg-transparent text-ink hover:border-[#0293cc] hover:text-[#0293cc] hover:bg-[#0293cc]/5 font-semibold",
  lime: "bg-[#CEDC00] text-[#0E1C2C] hover:bg-[#bac700] hover:text-[#0E1C2C] font-semibold tracking-wide shadow-sm",
  text: "text-[#0293cc] hover:text-[#0E1C2C] hover:bg-[#0293cc]/5 rounded-full px-4 py-1.5 font-medium",
};

export const Button = ({
  children,
  className = "",
  variant = "primary",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: keyof typeof variants;
}) => (
  <button className={`${baseClassName} ${variants[variant]} ${className}`.trim()} {...props}>
    {children}
  </button>
);

export const ButtonLink = ({
  children,
  className = "",
  variant = "primary",
  ...props
}: LinkProps & {
  children: ReactNode;
  variant?: keyof typeof variants;
}) => (
  <Link className={`${baseClassName} ${variants[variant]} ${className}`.trim()} {...props}>
    {children}
  </Link>
);
